
import { Component, Vue } from 'vue-property-decorator';
import DataTableWrapper from '@/features/common/components/DataTableWrapper.vue';

@Component({
  components: {
    DataTableWrapper,
  },
})
export default class ResultsTableSkeletonLoader extends Vue {}
